import { teamsDarkTheme, teamsHighContrastTheme, teamsLightTheme, } from '@fluentui/react-components';
export const THEME_PREFERENCES = [
    'system',
    'light',
    'dark',
];
/**
 * Escolha explícita da pessoa vence. Em "sistema", dentro do Teams vale o
 * tema do Teams (inclusive alto contraste); fora dele, o do sistema operacional.
 */
export function resolveTheme({ preference, teamsTheme, systemPrefersDark, }) {
    if (preference === 'light') {
        return teamsLightTheme;
    }
    if (preference === 'dark') {
        return teamsDarkTheme;
    }
    if (teamsTheme === 'contrast') {
        return teamsHighContrastTheme;
    }
    const dark = teamsTheme === null ? systemPrefersDark : teamsTheme === 'dark';
    return dark ? teamsDarkTheme : teamsLightTheme;
}
//# sourceMappingURL=theme.js.map